import { ReactNode } from "react";
import { Box, Divider, Typography, useMediaQuery, Theme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { brand } from "../../themes/brandTokens";

// The right-hand panel of a detail page: a grey aside, so it reads as a summary next to
// the main content rather than as a second card. Its title block has the height of the
// tab's own title, so both columns start on the same line; actions sit above the rows.
const QuickViewCard = ({ actions, children }: { actions?: ReactNode; children: ReactNode }) => {
  const { t }: { t: any } = useTranslation();
  const isMobile = useMediaQuery<Theme>((theme) => theme.breakpoints.down("sm"));
  return (
    <Box
      sx={{
        backgroundColor: brand.surfaceMuted,
        borderRadius: "16px",
        p: 2.5,
        // Quick view actions are secondary navigation: full-width white pills.
        "& .MuiButton-outlined, & .MuiButton-contained": { width: "100%" },
      }}
    >
      {!isMobile && (
        <Box pb={1.5}>
          <Typography variant="h6">{t("Quick view")}</Typography>
          <Typography variant="body2" color="text.secondary">
            {t("Key facts at a glance")}
          </Typography>
        </Box>
      )}
      {actions && (
        <>
          <Box py={1.5} display="flex" flexDirection="column" alignItems="center" gap={1} textAlign="center">
            {actions}
          </Box>
          <Divider />
        </>
      )}
      <Box pt={0.5}>{children}</Box>
    </Box>
  );
};

export default QuickViewCard;
